const setupExplainer = () => {
  const components = document.querySelectorAll('[data-component-explainer]');

  (components).forEach((component) => {
    const transitionInTimeline = gsap.timeline( {paused: true} );
    const setupTransitionInTimeline = (timeline) => {
      // timeline.fromTo(component, 1, {
      //   opacity: 0,
      // }, {
      //   opacity: 1,
      //   duration: 1,
      //   ease: Power3.easeOut,
      // });
    };

    // SETUP
    setupTransitionInTimeline(transitionInTimeline);

  });
};
setupExplainer();